import { render, staticRenderFns } from "./SettingsCatering.vue?vue&type=template&id=5609ddb8&scoped=true"
import script from "./SettingsCatering.vue?vue&type=script&lang=js"
export * from "./SettingsCatering.vue?vue&type=script&lang=js"
import style0 from "./SettingsCatering.vue?vue&type=style&index=0&id=5609ddb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609ddb8",
  null
  
)

export default component.exports